import { render, staticRenderFns } from "./cscenter-left-component.vue?vue&type=template&id=60edbc50&"
import script from "./cscenter-left-component.vue?vue&type=script&lang=js&"
export * from "./cscenter-left-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports